import React from 'react';

import Image from '../../../../library/image/image';
import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';

import { ServiceFlagData } from '../../../../shared/types/graphql-types';

import styles from './additional-store-services.scss';

interface AdditionalStoreServicesProps {
  servicesList: Array<ServiceFlagData>;
}

function AdditionalStoreServices(props: AdditionalStoreServicesProps) {
  const { servicesList } = props;

  return (
    <div className={styles['container']}>
      <Typography className={styles['header']}>Additional Services:</Typography>
      <div className={styles['services']}>
        {servicesList?.map(service => {
          const { code, iconUrl, link, name } = service;

          return (
            <div
              className={styles['service']}
              data-testid="additional-service"
              key={code}
            >
              {iconUrl && <Image alt={`${name} Icon`} src={iconUrl} />}
              {link ? (
                <Link to={link}>{name}</Link>
              ) : (
                <Typography
                  className={styles['service-text']}
                  size="small"
                  tag="span"
                  weight="black"
                >
                  {name}
                </Typography>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AdditionalStoreServices;
